import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";
import { useLocation } from "@reach/router";

const addTranscriptionServices = (postData) => {
  return http().post(endpoints.forms.transcriptionServices, postData);
};

export function useTranscriptionServices() {
  return useMutation(addTranscriptionServices, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
